
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 22","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 3.155v7.2a2.477 2.477 0 01-2.472 2.472h-.788v-1.039h.788c.788 0 1.433-.645 1.433-1.433v-7.2c0-.788-.645-1.433-1.433-1.433H8.131c-.788 0-1.432.645-1.432 1.433v.68h-1.04v-.68A2.477 2.477 0 018.132.684h13.433C22.89.684 24 1.794 24 3.155zM5.839 21.137l3.976-3.367h7.845A2.477 2.477 0 0020.13 15.3V6.88a2.477 2.477 0 00-2.471-2.472H2.472A2.477 2.477 0 000 6.881v8.418a2.477 2.477 0 002.472 2.471h2.185v2.83c0 .287.143.537.43.645.107.036.214.071.286.071.18 0 .323-.071.466-.179zm11.856-15.69c.789 0 1.433.646 1.433 1.434v8.418c0 .788-.644 1.432-1.433 1.432H9.457L5.73 19.884V16.73H2.507a1.437 1.437 0 01-1.432-1.433V6.882c0-.788.644-1.433 1.432-1.433h15.188zm-1.97 3.01H4.513a.628.628 0 00-.609.609c0 .322.287.609.61.609h11.211a.628.628 0 00.61-.61.628.628 0 00-.61-.608zm-1.182 3.833H4.513a.628.628 0 00-.609.609c0 .322.287.609.61.609h10.03a.628.628 0 00.608-.61.604.604 0 00-.609-.608z","fill":"currentColor"}})])
          )
        }
      }
    